import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import quizSelectors from 'store/quiz/selectors';

import {
  CardHeaderContainer,
  QuizName,
  ProgressHeader,
  SectionText,
  PercentCorrect,
} from './QuestionProgressHeader.styles';

const QuestionProgressHeader = ({
  currentQuiz,
  session,
}) => {
  if (!currentQuiz) {
    return (
      <CardHeaderContainer>
        <QuizName />
      </CardHeaderContainer>
    );
  }
  const { attempted, questionCount, correct } = session;
  const quizProgress = `${attempted} / ${questionCount}`;
  const percentCorrect = attempted === 0 ? `0%` : `${Math.round(((correct || 0) / attempted) * 100)}%`;

  return (
    <CardHeaderContainer>
      <QuizName> { session.quizName } </QuizName>
      <ProgressHeader>
          Progress:
        <SectionText> { quizProgress } </SectionText>
      </ProgressHeader>
      <PercentCorrect>
          Percent Correct:
        <SectionText> { percentCorrect } </SectionText>
      </PercentCorrect>
    </CardHeaderContainer>
  );
};

QuestionProgressHeader.propTypes = {
  currentQuiz: PropTypes.object,
  session: PropTypes.object,
};

export default connect((state) => {
  return {
    currentQuiz: quizSelectors.selectedQuiz(state),
    session: state.quiz.session,
  };
}, {
})(QuestionProgressHeader);
